import World from "@frog/source/models/World.js"
import Geometry from "@frog/source/utility/Geometry.js"

export default function calculateTrapRange({stage, unit, trap}) {
    // if(trap.distance == Infinity) return []
    // position, distance, direction
    const positions = []

    // TODO: unit.direction or effect.direction? Right now it's unit.direction
    const direction = unit.direction
    const position = unit.position

    // if(trap.distance != undefined) {
    //     if(trap.distance == 0) return positions
    //     for(let i = 1; i <= trap.distance; i += 1) {
    //         const position = Geometry.add(position, Geometry.multiply(direction, i))
    //         if(World.hasCollision2({"world": stage.world, position})) break
    //         positions.push(position)
    //     }
    // }

    if(trap.points != undefined) {
        let parallel, perpendicular, magnitude
        if(direction.x != 0) {
            parallel = "x"
            perpendicular = "y"
            magnitude = direction.x
        } else if(direction.y != 0) {
            parallel = "y"
            perpendicular = "x"
            magnitude = direction.y
        } else {
            return positions
        }

        trap.points.forEach((point) => {
            const position2 = Geometry.add(position, {
                // it's just been presumed that
                // x is the parallel and y is the perpendicular
                [parallel]: point.x * magnitude,
                [perpendicular]: point.y * magnitude,
            })
            if(World.hasCollision2({"world": stage.world, "position": position2, "zone": stage.encounters[stage.currentEncounter || 1].zone})) return
            positions.push(position2)
        })
    }

    return positions
}
